// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-jmH","name":"Header_name__228GQ","birthday":"Header_birthday__WjocF","skeleton":"Header_skeleton__Akvtg"};